




























import { Component, Prop, Vue } from 'vue-property-decorator';

type Payload = {
  name: string;
  infos: {
    unit: string;
    range: {
      base: {
        min: number;
        max: number;
      };
      minRange: {
        min: number;
        max: number;
      };
      maxRange: {
        min: number;
        max: number;
      };
      extremMin: number;
      extremMax: number;
    };
  };
  feet: {
    value: number;
    valStatut: number;
  };
};

@Component
export default class PatientAcquisitionExportationFrameWalkingOverviewGauge extends Vue {
  @Prop({ required: true }) private payload!: Payload;
  @Prop(Boolean) private rounded!: boolean;

  // Line colors
  graduations = ['red', 'orange', 'green', 'green', 'orange', 'red'];
  marginTop = 38;

  get wLine() {
    const dpi = document.getElementById('export-dpi-sensor')!.clientWidth;
    return (((210 - 14 * 2) * dpi) / 25.4 / 2 - 20) / this.graduations.length;
  }

  get segments(): [number, number, null, number, number] {
    return [
      this.payload.infos.range.minRange.min,
      this.payload.infos.range.minRange.max,
      null,
      this.payload.infos.range.maxRange.min,
      this.payload.infos.range.maxRange.max,
    ];
  }

  get feet(): number {
    return this.rounded ? Math.round(this.payload.feet.value) : parseFloat(this.payload.feet.value.toFixed(2));
  }

  get value() {
    const v =
      ((this.feet - this.payload.infos.range.extremMin) * (this.wLine * this.graduations.length)) /
      (this.payload.infos.range.extremMax - this.payload.infos.range.extremMin);

    if (v <= 20) {
      return 20;
    } else if (v >= this.wLine * this.graduations.length - 20) {
      return this.wLine * this.graduations.length - 20;
    } else {
      return v;
    }
  }

  get color() {
    switch (this.payload.feet.valStatut) {
      case 0:
        return 'red';
      case 1:
        return 'orange';
      case 2:
        return 'green';
      default:
        return 'black';
    }
  }
}
